// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2symv","loaderOuter":"PageOverlayLoader_loaderOuter__1lzsJ"};